import { render, staticRenderFns } from "./BranchesHome.vue?vue&type=template&id=3ee1a998&"
import script from "./BranchesHome.vue?vue&type=script&lang=js&"
export * from "./BranchesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports